import { NgModule } from '@angular/core';
import { OptionModule } from '../../../options/abstract/option.module';
import { HeaderCellComponent } from './header-cell.component';

@NgModule({
  imports: [OptionModule],
  declarations: [HeaderCellComponent],
  exports: [HeaderCellComponent]
})
export class HeaderCellModule {}
